export default __webpack_public_path__ + "static/media/Walk (1).1034caf9.png";